/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOMfaDetailsDTO } from "../models/ApiResponseDTOMfaDetailsDTO";
import type { ApiResponseDTOOTPVerifyDTO } from "../models/ApiResponseDTOOTPVerifyDTO";
import type { ApiResponseDTOSignInResponseDTO } from "../models/ApiResponseDTOSignInResponseDTO";
import type { ApiResponseDTOVoid } from "../models/ApiResponseDTOVoid";
import type { MfaEnableDetailsDTO } from "../models/MfaEnableDetailsDTO";
import type { MfaOtpCodeDTO } from "../models/MfaOtpCodeDTO";
import type { VerifyOtpDTO } from "../models/VerifyOtpDTO";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class MfaApiService {
  /**
   * Disable User MFA
   * Disable user TOTP MFA
   * @returns ApiResponseDTOVoid OK
   * @throws ApiError
   */
  public static disableMfa(): CancelablePromise<ApiResponseDTOVoid> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/mfa/totp/disable",
      errors: {
        401: `Unauthorized`,
        404: `Not Found`,
        406: `Not Acceptable`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Enable User MFA
   * Enable user TOTP MFA
   * @param requestBody
   * @returns ApiResponseDTOVoid OK
   * @throws ApiError
   */
  public static enableMfa(
    requestBody: MfaEnableDetailsDTO
  ): CancelablePromise<ApiResponseDTOVoid> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/mfa/totp/enable",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Unauthorized`,
        404: `Not Found`,
        406: `Not Acceptable`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Initiate MFA process
   * Get the details of setting up TOTP 2FA
   * @returns ApiResponseDTOMfaDetailsDTO OK
   * @throws ApiError
   */
  public static initiateMfa(): CancelablePromise<ApiResponseDTOMfaDetailsDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/mfa/totp/initiate",
      errors: {
        401: `Unauthorized`,
        404: `Not Found`,
        406: `Not Acceptable`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Verify OTP for MFA
   * Verify OTP for MFA by supplying the correct token that was sent to the user
   * @param requestBody
   * @returns ApiResponseDTOOTPVerifyDTO OK
   * @throws ApiError
   */
  public static verifyOtp1(
    requestBody: VerifyOtpDTO
  ): CancelablePromise<ApiResponseDTOOTPVerifyDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/mfa/totp/otp/verify",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Validate MFA OTP Code
   * Validate user provided MFA OTP Code
   * @param requestBody
   * @returns ApiResponseDTOSignInResponseDTO OK
   * @throws ApiError
   */
  public static validateMfa1(
    requestBody: MfaOtpCodeDTO
  ): CancelablePromise<ApiResponseDTOSignInResponseDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/mfa/totp/v2/validate",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Unauthorized`,
        404: `Not Found`,
        406: `Not Acceptable`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Validate MFA OTP Code
   * Validate user provided MFA OTP Code
   * @param username
   * @param requestBody
   * @returns ApiResponseDTOSignInResponseDTO OK
   * @throws ApiError
   */
  public static validateMfa(
    username: string,
    requestBody: MfaOtpCodeDTO
  ): CancelablePromise<ApiResponseDTOSignInResponseDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/mfa/totp/validate/{username}",
      path: {
        username: username,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Unauthorized`,
        404: `Not Found`,
        406: `Not Acceptable`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }
}
